import { Component, effect, inject, linkedSignal } from "@angular/core";
import { RouterLink } from "@angular/router";
import { NoOpLink } from "@kno2/common/directives";
import { LocalStorageService } from "@kno2/core/storage";
import { DialogService } from "@kno2/shared/dialog";
import { FeatureToggleDirective } from "@kno2/shared/features";
import { InfoPopoverComponent } from "@kno2/shared/info-popover";
import { NonPhiFaxComponent } from "./non-phi-fax/non-phi-fax.component";
import { ReleaseDraftsComponent } from "./release-drafts.component";
import { ReleaseHistoryComponent } from "./release-history.component";

const RELEASE_ACTIVE_TABS_KEY = "release.activeTab";

@Component({
    selector: "kno2-release",
    imports: [NoOpLink, RouterLink, InfoPopoverComponent, ReleaseHistoryComponent, ReleaseDraftsComponent, FeatureToggleDirective],
    templateUrl: "./release.component.html"
})
export class ReleaseComponent {
    private readonly localStorageService = inject(LocalStorageService);
    private readonly dialogService = inject(DialogService);

    protected activeTab = linkedSignal(() => this.localStorageService.get(RELEASE_ACTIVE_TABS_KEY) || "events");
    protected setActiveTabEffect = effect(() => this.localStorageService.set(RELEASE_ACTIVE_TABS_KEY, this.activeTab()));

    public async showNonPhiFaxModal(): Promise<void> {
        await this.dialogService.open(NonPhiFaxComponent, { headerText: "Send Non-PHI Fax" });
    }
}
